// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"d306730a","10":"5ea11c02","53":"4a77ac70","135":"5854f821"}[chunkId] + ".chunk.css";
};